import React from "react";

import Topbar from "../Topbar/index.js";
import { Content, Main, Wrapper } from "./styles.js";

const MainContainer = ({
  alignCenter,
  topbar,
  topbarWithBottomBar,
  children,
}) => {
  return (
    <Wrapper>
      {topbar && <Topbar withBottomBar={topbarWithBottomBar}>{topbar}</Topbar>}
      <Main>
        <Content alignCenter={alignCenter}>{children}</Content>
      </Main>
    </Wrapper>
  );
};

export default MainContainer;
